import React, {Component} from "react";
import {Link} from "react-router-dom";
import './Signup.css';


class RegistrationNotOk extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="signup-container">
                <div className="signup-content">
                    <h3 className="page-title">Üzgünüm Hesap Aktifleştirme Başarısız!</h3>
                    <h3 className="page-title">Daha Önce Aktivasyon Gerçekleştirdiyseniz Sisteme Giriş
                        Yapabilirsiniz.</h3>
                    <br/>
                    <div className="center-link">
                        <Link to="/login">Giriş Sayfası</Link>
                    </div>
                </div>
            </div>
        );
    }
}

export default RegistrationNotOk;


// WEBPACK FOOTER //
// ./src/page/signup/RegistrationNotOk.js